export default __webpack_public_path__ + "static/cross-reference-illu-9da3f175a48db127eeee237953ac90e7.png";